<section class="landing-inversores__media">
  <div class="landing-inversores__container landing-inversores__media-inner">
    <p class="landing-inversores__eyebrow landing-inversores__media-eyebrow">En los medios</p>
    <h2 class="landing-inversores__section-title landing-inversores__media-title">Hablan de nosotros</h2>

    <div class="landing-inversores__media-grid">
      <a
        *ngFor="let m of mentions"
        class="landing-inversores__media-card landing-inversores__shadow-soft landing-inversores__media-card--{{ m.themeClass }}"
        [href]="m.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div class="landing-inversores__media-card-head">
          <span class="landing-inversores__media-card-name">{{ m.name }}</span>
          <landing-inversores-icon name="arrow-up-right" class="landing-inversores__media-card-icon"></landing-inversores-icon>
        </div>
        <p class="landing-inversores__media-card-quote">&ldquo;{{ m.quote }}&rdquo;</p>
      </a>
    </div>
  </div>
</section>
